import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ImageSizeTitle } from "../../../../Constants/Constants";
import { ImageData, ImageSubTitle } from "../../../../Data/UiKits/HelperClasses";

const ImageSize = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={ImageSizeTitle} span={ImageSubTitle} />
        <CardBody>
          <div className="gradient-border gap-3">{ImageData && ImageData.map((item, index) => <Image className={`img-${item} img-h-${item}`} src={dynamicImage(`blog/comment.jpg`)} alt="img-size" key={index} />)}</div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ImageSize;
